import { registerPromotion } from './promotion-registry';
import { promote as webhookWebhook1to2 } from './steps/webhook-webhook-1-to-2';
import { promote as webhookWebhook2to3 } from './steps/webhook-webhook-2-to-3';
import { promote as webhookWebhook3to4 } from './steps/webhook-webhook-3-to-4';
import { promote as webhookWebhook4to5 } from './steps/webhook-webhook-4-to-5';
import { promote as webhookWebhook5to6 } from './steps/webhook-webhook-5-to-6';
import { promote as smtpSendEmail1To2 } from './steps/smtp-send-email-1-to-2';
import { promote as zendeskCreateTicket4To5 } from './steps/zendesk-create-ticket-4-to-5';
import { promote as flowControlDelay1To2 } from './steps/flow-control-delay-1-to-2';
import { promote as callUpdateVariables1To2 } from './steps/call-update-variables-1-to-2';
import { promote as webhookWebhook6To7 } from './steps/webhook-webhook-6-to-7';
import { promote as callHandoff1To2 } from './steps/call-handoff-1-to-2';
import { promote as chatHandoff1To2 } from './steps/chat-handoff-1-to-2';
import { promote as parseAttachment1To2 } from './steps/parse-attachment-1-to-2';
import { promote as hubspotGetMeetingAvailability1To2 } from './steps/hubspot-get-meeting-availability-1-to-2';
registerPromotion('Webhook', 'Webhook', 1, 2, webhookWebhook1to2);
registerPromotion('Webhook', 'Webhook', 2, 3, webhookWebhook2to3);
registerPromotion('Webhook', 'Webhook', 3, 4, webhookWebhook3to4);
registerPromotion('Webhook', 'Webhook', 4, 5, webhookWebhook4to5);
registerPromotion('Webhook', 'Webhook', 5, 6, webhookWebhook5to6);
registerPromotion('SMTP', 'Send-email', 1, 2, smtpSendEmail1To2);
registerPromotion('Zendesk', 'Create-ticket', 4, 5, zendeskCreateTicket4To5);
registerPromotion('Flow-control', 'Delay', 1, 2, flowControlDelay1To2);
registerPromotion('Call', 'Update-variables', 1, 2, callUpdateVariables1To2);
registerPromotion('Webhook', 'Webhook', 6, 7, webhookWebhook6To7);
registerPromotion('Call', 'Handoff', 1, 2, callHandoff1To2);
registerPromotion('Chat', 'Handoff', 1, 2, chatHandoff1To2);
registerPromotion('Parse', 'Attachment', 1, 2, parseAttachment1To2);
registerPromotion('Hubspot', 'Get-meeting-availability', 1, 2, hubspotGetMeetingAvailability1To2);
export { canPromote, promoteConfig, getLatestVersions, registerPromotion } from './promotion-registry';
//# sourceMappingURL=index.js.map